import { httpService } from 'shared/api';
import { ISubscription } from './types';

export const creditApi = {
  getCurrentSubscriptions: async (key: string) => {
    const data = await httpService.get<ISubscription[]>(
      '/payments/subscriptions',
      {
        headers: {
          'x-api-key': key
        }
      }
    );
    return data.data;
  }
};
